import ApiService from "../api.services";

const OrderServicesService = {
  list: async function (records, page) {
    try {
      const response = await ApiService.get(`/api/os/${records}/${page}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async function (records, page, startedAt, finishedAt, filter) {
    try {
      const response = await ApiService.post(
        `/api/os/filter?records=${records}&page=${page}&startedAt=${startedAt}&finishedAt=${finishedAt}`,
        filter
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/os/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  add: async function (form) {
    try {
      const data = {
        os: form,
      };
      const res = await ApiService.post("/api/os", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  update: async function (id, form) {
    const data = {
      os: form,
    };
    try {
      const response = await ApiService.put(`/api/os/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  print: async function (id) {
    try {
      const response = await ApiService.post(`/api/os/print/${id}`, {});
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  close: async function (id) {
    try {
      const response = await ApiService.post(`/api/os/close/${id}`, {});
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/os/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOpenByCustomer: async function (customer_id) {
    try {
      const response = await ApiService.get(
        `/api/os/find/bycustomer/${customer_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateObjects: async function ({ order_service_id, preposts, actionType }) {
    try {
      const response = await ApiService.put(`/api/os/objects/update`, {
        order_service_id,
        preposts,
        actionType,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  countTotalByService: async ({ orders_ids, delivery_os_id }) => {
    try {
      const response = await ApiService.filter(
        "/api/os/count/totalservices/byorders",
        { params: { delivery_os_id, orders_ids } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findByPendencyId: async (pendency_id) => {
    try {
      const response = await ApiService.get(
        `/api/os/find/bypendency/${pendency_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default OrderServicesService;

export { OrderServicesService };
